import { useTranslation } from "react-i18next";
import ClipBoardIcon from "../../../icons/clipBoardIcon";

const CustomTariffs = () => {
  const { t } = useTranslation();
  return (
    <main>
      <article className="py-20">
        <div className="w-11/12 mx-auto">
          <span className="block mx-auto w-fit">
            <ClipBoardIcon className={"size-[60px]"} />
          </span>
          <h1 className="text-[24px] my-5 md:text-[32px] font-bold text-mainBlue text-center">
            {t("customTariffs")}
          </h1>
          <p className="mx-auto my-10 text-lg text-center text-mainGray">
            {t("CustomsTariffsAreTaxes")}
          </p>
          <section className="space-y-8">
            <h2 className="text-xl font-bold text-mainRed">
              {t("whatAreCustomsTariffs")}
            </h2>
            <p>
              <span className="text-mainRed">{t("CountryOfOrigin")}</span>
              {t("theHarmonizedSystem")}
            </p>
            <p>
              <span className="text-mainRed">{t("ValueOfGoods")}</span>
              {t("customsDuties")}
            </p>
            <p>
              <span className="text-mainRed">{t("tradeReductions")}</span>
              {t("someCountriesProvide")}
            </p>
            <p>
              <span className="text-mainRed">{t("productClassification")}</span>
              {t("eachProductIsClassified")}
            </p>
            <p>
              <span className="text-mainRed">{t("additionalCosts")}</span>
              {t("someCountriesChargeTaxes")}
            </p>
            <p>
              <span className="text-mainRed">{t("requiredDocumentation")}</span>
              {t("whenImportingGoods")}
            </p>
            <p>
              <span className="text-mainRed">{t("costPlanning")}</span>
              {t("accurateDocumentation")}
            </p>
            <p>
              <span className="text-mainRed">{t("legalCompliance")}</span>
              {t("itIsCrucialToFollow")}
            </p>
            <p>
              <span className="text-mainRed">{t("restrictionsOnProducts")}</span>
              {t("someCountriesImpose")}
            </p>
            <p>
              <span className="text-mainRed">{t("accurateDocumentation-")}</span>
              {t("incorrectOrMissing")}
            </p>
          </section>
        </div>
      </article>
    </main>
  );
};

export default CustomTariffs;
